import { render, staticRenderFns } from "./TheMainCard.vue?vue&type=template&id=dba5140a&scoped=true&"
import script from "./TheMainCard.vue?vue&type=script&lang=ts&"
export * from "./TheMainCard.vue?vue&type=script&lang=ts&"
import style0 from "./TheMainCard.vue?vue&type=style&index=0&id=dba5140a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dba5140a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
